import React, { useEffect, useState } from "react";
import "./AmountCard.css";
import info from "../../../assets/icons/order-info.png";
import TotalAmountDetailsModal from "./WithdrawDetailsModal.tsx";
import axios from "axios";

const AmountCard = ({ title, amount, withdrawableAmount, icon, colorCode, usedIn = "", pendingAmount, }) => {
    const [orderHistoryLogDetailsAmount, setOrderHistoryLogDetailsAmount] = useState({});
    const [open, setOpen] = useState(false);

    const handleOpen = (e) => {
        e.stopPropagation();
        setOpen(true);
        return;
    };

    const handleClose = (e) => {
        e.stopPropagation();
        setOpen(false);
    }

    const modalClick = (e) => {
        e.stopPropagation();
    }

    const loadOrderHistoryLogAmountDetails = async () => {
        let restaurant = localStorage.getItem("restaurant");
        let restaurantObj = restaurant ? JSON.parse(restaurant) : null;
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_SECRET}/api/OrderHistoryLog/GetOrderHistoryLogDetailsAmount?restaurantId=${restaurantObj?.id}`);
            if (response !== null) {
                setOrderHistoryLogDetailsAmount(response.data);
            }
        } catch (error) {
            console.log('Error fetching order history log details amount:', error);
        }
    }

    useEffect(() => {
        if (open) {
            loadOrderHistoryLogAmountDetails();
        }
    }, [open]);

    return (
        <div className="amount-card d-flex flex-column gap-2" style={{ minWidth: '245px', position: 'relative' }}>
            <div className="d-flex gap-3 align-items-center justify-content-between">
                <div>
                    <div className="amount-text">{title}</div>
                    <div className="amount">{amount}</div>
                </div>
                <div className="amount-icon" style={{ backgroundColor: colorCode }}>
                    <img src={icon} alt="icon" />
                </div>
            </div>
            <div>
                <div className="amount-text_sm_pending text-muted">
                    Pending {usedIn}: <span className="amount_sm">{pendingAmount}</span>
                </div>
                <div className="amount-text_sm_withdrawable">
                    Withdrawable {usedIn}: <span className="amount_sm">{withdrawableAmount}</span>
                </div>
            </div>

            <div
                onClick={(e) => handleOpen(e)}
                style={{ position: 'absolute', bottom: '5px', right: '5px', cursor: 'pointer' }}
            >
                <img src={info} style={{ width: '20px', height: '20px' }} />
            </div>

            {open &&
                <div onClick={(e) => modalClick(e)}>
                    <TotalAmountDetailsModal open={open} handleClose={handleClose} orderhistorylogdetailsamount={orderHistoryLogDetailsAmount} />
                </div>
            }

        </div>
    )
}

export default AmountCard;